import { StoplightElementsEvent, StoplightElementsListener } from './listeners';

let config: string[] = [];

export function configureStoreFields(fields: string[]): void {
  config = fields;
}

window.addEventListener(StoplightElementsListener.TryItPanelAdded, (e) => {
  const event = e as StoplightElementsEvent;
  for (const field of config) {
    const selector = `[id^="id_${field}_"]`; // Stoplight Elements generates ids for TryItPanel inputs in the format id_{field}_{randomString}, so we find input by looking at ids that start with id_{field}_
    const input = event.detail?.node.querySelector(selector);
    if (input instanceof HTMLInputElement) {
      loadStoredValue(field, input);
      input.addEventListener('change', () => storeValue(field, input));
    }
  }
});

// React controls this input internally, so a direct assignment gets overwritten on re-render.
// Using the native setter + dispatching 'input' triggers React's synthetic event system.
const nativeInputValueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;

const keyForField = (field: string) => `TryItPanel-${field}`;

const loadStoredValue = (field: string, input: HTMLInputElement) => {
  const key = keyForField(field);
  const value = sessionStorage.getItem(key);
  if (value !== null) {
    nativeInputValueSetter?.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
};

const storeValue = (field: string, input: HTMLInputElement): void => {
  const key = keyForField(field);
  sessionStorage.setItem(key, input.value);
};
